export const LOCAL_STORAGE_NAMESPACE = {
	userId: "user_id",
	userName: "user_name",
	token: "token",
} as const;
